import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings, mediaQuery } from '@styles/index';
import TrialClasses from '@cont/Batch/TrialClasses';

const Wrapper = styled.div`
  grid-column: span 16;
  & > div {
    margin-bottom: -${Spacings.SPACING_8B};
    grid-row-gap: ${Spacings.SPACING_8B};
    > :nth-child(1) {
      grid-column: span 24;
    }
    > :nth-child(2) {
      grid-column: span 24;
    }
  }
  ${mediaQuery.uptoMobile} {
    & > div {
      grid-row-gap: ${Spacings.SPACING_0B};
      margin-top: -${Spacings.SPACING_10B};
      margin-bottom: -${Spacings.SPACING_10B};
    }
  }
`;

const config = { title: 'Demo classes', description: null };
const PFTrialClasses = ({
  trialClasses,
  batchUID,
  goalUID,
  disabledTopicGroup,
  hideLessonCount
}) => {
  return (
    <Wrapper>
      <TrialClasses
        batchUID={batchUID}
        trialClasses={trialClasses}
        goalUID={goalUID}
        config={config}
        disabledTopicGroup={disabledTopicGroup}
        hideLessonCount={hideLessonCount}
        isBatchGroup
        step={2}
      />
    </Wrapper>
  );
};

export default PFTrialClasses;

PFTrialClasses.propTypes = {
  trialClasses: PropTypes.objectOf(PropTypes.any).isRequired,
  batchUID: PropTypes.string.isRequired,
  goalUID: PropTypes.string.isRequired
};
